module.exports = __webpack_public_path__ + "img/license_privacy_security.e844ec28.svg";